<template>
    <i class="fa fa-users" :style="{opacity: ad.third_party_costs ? 1 : 0.2}" v-tooltip="tooltip"></i>
</template>

<script>
    export default {
        props: {
            ad: {
                type: Object,
                required: true
            }
        },

        computed: {
            tooltip() {
                if(this.ad.third_party_costs) {
                    return 'Third Party Costs: ' + this.$options.filters.price(this.ad.third_party_costs)
                }
            }
        }
    }
</script>
